export default __webpack_public_path__ + "static/david-e4152af87b1cb0b38c7af691c51bd669.png";